import { Component, HostListener, OnInit } from '@angular/core';
import { SesionService } from 'src/app/core/service/sesion.service';
import { TaxValidation } from '../tax-validation/model/tax-validation';
import { PotentialCustomer } from '../potential-customer/model/potential-customer';
import {
  FileSave,
  UploadScreenInfo,
} from 'src/app/shared/components/atoms/file-upload-component/model/file-uplaod.interface';
import { SalesValidation } from '../sales-validation/model/sales-validation.interface';
import { ContactInformation, UploadFileContactInformation } from '../contact-information/model/potential-customer';
import { FileToSaveData, InfoClienteDocumentUpload, RegisterCompleteService } from './service/register-complete.service';
import {
  ClientFileInfo,
  OptionAtributte,
  Customer,
  CustomerAddress,
  ContactInformationRequest,
  TaxInformation,
  AdditionalInformation,
  AlcoholicSalesLicense,
} from './model/register-complete';
import { DocumentId } from 'src/app/core/model/constans';
import { Utils } from 'src/app/core/service/utils/regex-list.regex';
import { environment } from 'src/environments/environment';
import { BIO_CUSTOMER_BIOMETRIC_SESSION_KEY, BioCustomerBiometricSession } from '../file-upload/model/bio-process.model';

@Component({
  selector: 'app-register-complete',
  templateUrl: './register-complete.component.html',
  styleUrls: ['./register-complete.component.scss'],
})
export class RegisterCompleteComponent implements OnInit {
  percentage: number = 0;
  taxValidationData: TaxValidation | null;
  potentialCustomerData: PotentialCustomer | null;
  salesValidationData?: SalesValidation | null;
  uploadFileData: UploadScreenInfo | null;
  contacInformation: ContactInformation | null;
  uploadFileOptional: UploadFileContactInformation | null;
  salesValidation: SalesValidation | null;
  cantFiles: number = 0;
  filesSave: FileToSaveData[] = [];
  infoClientFile: ClientFileInfo | undefined;
  error: boolean = false;
  isLoading: boolean = true;
  
  constructor(private readonly sesion: SesionService, private readonly service: RegisterCompleteService) {
    this.percentage = 0;
    this.potentialCustomerData = this.sesion.getItem('potential_customer');
    this.salesValidation = this.sesion.getItem('sales_validation');
    this.taxValidationData = this.sesion.getItem('tax_validation');

    this.uploadFileData = {
      fileDoc: [],
      dniValidationRequired: false,
    };
    this.uploadFileOptional = {};
    this.service.getUploadFile().subscribe((data) => {
      this.uploadFileData = data;
    });
    this.service.getPremisesPhoto().subscribe((data) => {
      this.uploadFileOptional = data;
    });
    this.contacInformation = JSON.parse(this.sesion.getItem('contact-information') ?? '{}') as ContactInformation;
  }

  ngOnInit(): void {
    this.percentage = 0;
    this.saveInfo();
  }

  removeAccents(accentedText: string): string {
    const unaccentedText = accentedText.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return unaccentedText;
  }

  saveInfo() {
    if (this.salesValidation && this.potentialCustomerData && this.taxValidationData && this.contacInformation?.timeA) {
      let deliveryTimeMorning: string = this.contacInformation.timeA.start + ' to ' + this.contacInformation.timeA.end;
      let deliveryTimeEvening: string = this.contacInformation.timeB.start + ' to ' + this.contacInformation.timeB.end;

      let customerAddress: CustomerAddress = {
        country: 'argentina',
        state: this.removeAccents(this.potentialCustomerData.location.state),
        city: this.removeAccents(this.potentialCustomerData.location.city),
        street: this.removeAccents(this.potentialCustomerData.location.street),
        houseNumber: Number(this.potentialCustomerData.location.streetNumber),
        latitude: String(this.potentialCustomerData.location.coordinates.lat),
        longitude: String(this.potentialCustomerData.location.coordinates.lon),
        postCode: this.potentialCustomerData.location.postCode,
        betweenStreets: this.potentialCustomerData.location.entreCalles,
        floorUnitDepartment: this.potentialCustomerData.location.depto ? this.potentialCustomerData.location.depto : '',
      };

      let identificationType = this.taxValidationData.noCuit ? 'CUIL' : 'CUIT';
      let taxInformation: TaxInformation = {
        personType: this.taxValidationData.infoAfip?.typePerson ? this.taxValidationData.infoAfip?.typePerson : 'F',
        identificationNumber: this.taxValidationData.numIdentification,
        identificationType: identificationType,
        attachedDocumentType: this.setAttach(),
        iibbNumber: Number(this.taxValidationData.IIBBNumber),
        iibbCategoryId: Number(this.taxValidationData.IIBBCondition),
        iibbRate: this.taxValidationData.aliCuota[0] ?? 0,
        iibbCondition: this.taxValidationData.infoAfip?.ivaCondition
          ? this.taxValidationData.infoAfip?.ivaCondition
          : 'NO CATEGORIZADO',
        fiscalAddress: this.taxValidationData.infoAfip?.taxResidence
          ? this.taxValidationData.infoAfip?.taxResidence
          : this.potentialCustomerData.location.address,
        dniValidationRequired: this.uploadFileData?.dniValidationRequired
          ? this.uploadFileData?.dniValidationRequired
          : false,
        name: this.taxValidationData.name ? this.taxValidationData.name : '',
        lastname: this.taxValidationData.lastName ? this.taxValidationData.lastName : '',
      };
      if (Number(this.taxValidationData.IIBBCondition) == 4) {
        taxInformation.iibbRateCond1 = this.taxValidationData.aliCuota?.[0] ?? taxInformation.iibbRateCond1;
        taxInformation.iibbRateCond2 = this.taxValidationData.aliCuota?.[1] ?? taxInformation.iibbRateCond2;
        taxInformation.iibbRateCond3 = this.taxValidationData.aliCuota?.[2] ?? taxInformation.iibbRateCond3;
        taxInformation.iibbJurisdiction = this.taxValidationData.IIBBJurisdiction;
      }
      if (this.taxValidationData.infoAfip) {
        taxInformation.infoAfip = {
          simplifiedMonotributo: this.taxValidationData.infoAfip.simplifiedMonotributo,
          municipalContribution: this.taxValidationData.infoAfip.municipalContribution,
          convenioMultilateral: this.taxValidationData.infoAfip.convenioMultilateral,
          ivaCondition: this.taxValidationData.infoAfip.ivaCondition,
        };
      }
      if (this.taxValidationData.municipalContribution || !this.taxValidationData.municipalContribution) {
        taxInformation.municipalContribution = this.taxValidationData.infoAfip?.municipalContribution;
        if (this.taxValidationData.numMunicipalContribution) {
          taxInformation.numMunicipalContribution = this.taxValidationData.numMunicipalContribution;
        }
      }
      let reba: AlcoholicSalesLicense = {};
      if (this.taxValidationData.infoREBA?.code) {
        reba.rebaDate = this.taxValidationData.infoREBA?.expiredDate;
        reba.rebaLicenseNumber = Number(this.taxValidationData.infoREBA?.code);
      }

      let additionalInformation: AdditionalInformation = {};
      if (this.taxValidationData.infoAfip?.typePerson.toUpperCase() != 'J') {
        let document = Utils.getDni(this.taxValidationData.numIdentification);
        additionalInformation.documentNumber = document;
        additionalInformation.documentType = 'DNI';
      }

      let contactInformationRequest: ContactInformationRequest = {
        email: this.contacInformation.email,
        phoneNumber: this.contacInformation.telephone,
        scheduleContactMorning: deliveryTimeMorning,
        scheduleContactEvening: deliveryTimeEvening,
      };

      if (this.contacInformation.secondaryTelephone) {
        contactInformationRequest.phoneNumSecondary = this.contacInformation.secondaryTelephone;
      }

      let data: Customer = {
        companyName: this.taxValidationData.infoAfip?.bussinesName
          ? this.taxValidationData.infoAfip?.bussinesName
          : this.taxValidationData.nameComplete,
        fantasyName: this.potentialCustomerData.fantasyName,
        requestDate: new Date(),
        treeAnswersFinalId: this.salesValidation.idAnswersFinal,
        customerAddress: customerAddress,
        alcoholicSalesLicense: reba,
        additionalInformation: additionalInformation,
        contactInformation: contactInformationRequest,
        taxInformation: taxInformation,
        ...(this.potentialCustomerData.location.erpDistributorClientId && {
          erpDistributorClientId: this.potentialCustomerData.location.erpDistributorClientId,
        }),
        ...(this.potentialCustomerData.location.erpDistributorClientName && {
          erpDistributorClientName: this.potentialCustomerData.location.erpDistributorClientName,
        }),
      };

      const biometric = environment.features?.enableBioDocumentValidation
        ? this.sesion.getItem<BioCustomerBiometricSession>(BIO_CUSTOMER_BIOMETRIC_SESSION_KEY)
        : null;
      if (biometric?.customerBiometricId != null) {
        data.customerBiometricId = biometric.customerBiometricId;
      }

      this.service.saveInfo(data).subscribe((resp) => {
        this.saveFile(resp.newCustomerId, resp.customerRequestId);
      }, (error) => {
        this.error = true;
        this.isLoading = false;
      });
    }
  }

  finish() {
    console.log('finish');
  }

  retry(){
    this.isLoading = true;
    this.saveInfo();
  }

  saveFile(newCustomerId: number, customerRequestId: number) {
    // se guardan las otras lambdas que no son la de archivos
    this.setInfoClientFile(newCustomerId, customerRequestId);
    if (this.uploadFileData) {
      for (let fileDocData of this.uploadFileData.fileDoc) {
        this.addFile(fileDocData.files);
      }
      if (this.uploadFileOptional?.uploadFile0) {
        this.addFile(this.uploadFileOptional?.uploadFile0);
      }
      if (this.uploadFileOptional?.uploadFile1) {
        this.addFile(this.uploadFileOptional?.uploadFile1);
      }
      this.uploadFiles();
    }
  }

  addFile(filesDto: FileSave[]) {
    this.cantFiles += filesDto.length;
    for (let file of filesDto) {
      const filename = file.name;
      const contentType = file.type;
      this.filesSave.push({
        documentTypeId: file.id,
        fileData: {
          contentType,
          filename,
        },
      });
    }
  }

  setInfoClientFile(newCustomerId: number, customerRequestId: number) {
    if (this.taxValidationData?.numIdentification) {
      this.infoClientFile = {
        cuit: this.taxValidationData.numIdentification,
        customerId: newCustomerId,
        requestId: customerRequestId,
        documentTypeId: 1,
      };
    }
  }

  dataURItoBlob(dataURI: any) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/png' });
    return blob;
  }

  uploadFiles() {
    const infoCliente: InfoClienteDocumentUpload = {
      identificationNumber: this.infoClientFile?.cuit,
      customerId: this.infoClientFile?.customerId,
      requestId: this.infoClientFile?.requestId,
    };
    this.service.organizeFiles(this.filesSave, infoCliente).subscribe(() => {
      this.percentage = 100;
      this.service.deleteStore();
      this.service.deleteSessionStore();
      this.isLoading = false;
      this.error = false;
    }, (error) => {
      this.error = true;
      this.isLoading = false;
    });
  }

  calculatePercentage(cantExported: number) {
    return Math.round(((cantExported + 0.5) * 100) / this.cantFiles);
  }

  checkIfCuilHasDocument(): boolean {
    if (this.taxValidationData?.noCuit) {
      let hasCuilDocument: boolean = false;
      if (this.uploadFileData?.fileDoc) {
        this.uploadFileData.fileDoc.forEach((x) => {
          if (!hasCuilDocument) {
            if (x.files.length > 0) {
              hasCuilDocument = x.files.some((x) => x.id == DocumentId.CONSTANCIA_CUIL);
            }
          }
        });
      }
      return this.taxValidationData.noCuit && !hasCuilDocument;
    } else {
      return false;
    }
  }

  setAttach(): OptionAtributte[] {
    let option: OptionAtributte[] = [];
    let resultAttachCuil = this.checkIfCuilHasDocument();
    if (resultAttachCuil) {
      let attachCuil: OptionAtributte = {
        value: DocumentId.CONSTANCIA_CUIL,
      };
      option.push(attachCuil);
    }
    if (this.uploadFileData?.attachIIBBDocument) {
      let attachIIBBCondition: OptionAtributte = {
        value: DocumentId.CONSTANCIA_IIBB,
      };
      option.push(attachIIBBCondition);
    }
    return option;
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event: { returnValue: boolean }) {
    if (this.percentage < 100) {
      event.returnValue = true;
    }
  }
}
